// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { StoreSlugs } from '@iheartjane/data-access';
import { CheckIcon, CopyIcon, Flex, Tag, Typography } from '@iheartjane/reefer';
import { useState } from 'react';

import type { BloomStore } from '@jane/business-admin/types';
import { generateStoreUrl } from '@jane/business-admin/util';

const StyledFlex = styled(Flex)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.grays.light}`,
  paddingBottom: 24,

  '&:last-child': {
    borderBottom: 0,
    paddingBottom: 0,
  },
}));

const StyledTypography = styled(Typography)(() => ({
  textDecoration: 'underline',
  textDecorationStyle: 'dashed' as const,
  textUnderlineOffset: '6px',
  textDecorationColor: 'var(--colors-grays-mid)',
  cursor: 'pointer',
}));

export const StoreSection = ({
  store,
  menuUrl,
  storeSlugs,
}: {
  menuUrl: string;
  store: BloomStore;
  storeSlugs?: StoreSlugs;
}) => {
  const storeAddress = `${store.address}, ${store.city}, ${store.state} ${store.zip}`;
  const storeUrl = generateStoreUrl(menuUrl, store.id, storeSlugs);

  const [showCopied, setShowCopied] = useState(false);

  return (
    <StyledFlex flexDirection="row" p={24}>
      <Flex alignItems="center">
        <Tag
          label={store.recreational ? 'Rec' : 'Med'}
          color={store.recreational ? 'purple' : 'palm-dark'}
          background={store.recreational ? 'purple-light' : 'palm-light'}
        />
      </Flex>

      <Flex flexDirection="column" ml={24} width="100%">
        <Typography variant="body-bold">{store.name}</Typography>
        <Typography color="grays-mid">{storeAddress}</Typography>
        <Typography color="grays-mid">{storeUrl}</Typography>
      </Flex>
      <Flex mt={8} alignItems="flex-end" justifyContent="flex-end" width="100%">
        <Flex
          alignItems="center"
          aria-label="Copy store url"
          onClick={() => {
            setShowCopied(true);
            navigator.clipboard.writeText(storeUrl);

            setTimeout(() => {
              setShowCopied(false);
            }, 1000);
          }}
        >
          {showCopied ? <CheckIcon /> : <CopyIcon size="sm" />}
          <StyledTypography color="grays-dark" ml={8}>
            Copy link
          </StyledTypography>
        </Flex>
      </Flex>
    </StyledFlex>
  );
};
